import * as React from "react";
import { forwardRef } from "react";
const SvgRowUnlock = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={21} height={21} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h21v21H0z" /><path d="M16.014 7.559A2.554 2.554 0 0 0 13.466 5a2.554 2.554 0 0 0-2.549 2.559v2.483" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" /><path d="M12.968 10.824c0-.553-.42-1-.938-1H5.937c-.517 0-.937.447-.937 1v5c0 .552.42 1 .937 1h6.093c.518 0 .938-.448.938-1v-5z" fill="currentColor" /></g></svg>;
const ForwardRef = forwardRef(SvgRowUnlock);
export { ForwardRef as ReactComponent };